import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import { IconCheckCircle, IconBan, IconTrash } from '../components/Icons';
import '../components/AdminUI.css';

export default function Reviews() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('');
  const load = () => axios.get('/reviews', { params: filter !== '' ? { approved: filter } : {} }).then((r) => setItems(r.data.data || []));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);
  const approve = async (id) => { await axios.post(`/reviews/${id}/approve`); load(); };
  const reject = async (id) => { await axios.post(`/reviews/${id}/reject`); load(); };
  const remove = async (id) => { if (window.confirm('Supprimer ?')) { await axios.delete(`/reviews/${id}`); load(); } };

  return (
    <div className="admin-page">
      <div className="admin-toolbar">
        <select className="admin-select" value={filter} onChange={(e) => setFilter(e.target.value)} style={{ maxWidth: 220 }}>
          <option value="">Tous</option>
          <option value="false">À modérer</option>
          <option value="true">Approuvés</option>
        </select>
      </div>
      <div className="admin-card" style={{ padding: 0, overflow: 'auto' }}>
        <table className="admin-table">
          <thead><tr><th>Produit</th><th>Auteur</th><th>Note</th><th>Commentaire</th><th>Statut</th><th></th></tr></thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id}>
                <td>{r.product?.ref} {r.product?.marque_nom}</td>
                <td>{r.author_name}<br /><small>{r.author_email}</small></td>
                <td>{'★'.repeat(r.rating)}</td>
                <td style={{ maxWidth: 360 }}>{r.title && <strong>{r.title}<br /></strong>}{r.comment}</td>
                <td><span className={`admin-pill ${r.is_approved ? 'green' : 'amber'}`}>{r.is_approved ? 'approuvé' : 'en attente'}</span></td>
                <td>
                  <div className="admin-actions">
                    {!r.is_approved ? (
                      <button className="admin-icon-btn is-success" title="Approuver" aria-label="Approuver" onClick={() => approve(r.id)}>
                        <IconCheckCircle />
                      </button>
                    ) : (
                      <button className="admin-icon-btn" title="Rejeter" aria-label="Rejeter" onClick={() => reject(r.id)}>
                        <IconBan />
                      </button>
                    )}
                    <button className="admin-icon-btn is-danger" title="Supprimer" aria-label="Supprimer" onClick={() => remove(r.id)}>
                      <IconTrash />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
